<n-data-table
    #dt
    [columnDefs]="tableColumnDefs"
    [config]="tableConfig"
    [data]="quotaData"
    [loading]="loading"
    id="quota-report">
</n-data-table>
